import { useDispatch, useSelector } from 'react-redux'
import { PowerIcon } from '@heroicons/react/24/outline'
import wretch from 'wretch'

import { getCsrfToken } from '@/utils/csrf'
import { clearAuthData } from './auth/authSlice'

export default () => {
  const dispatch = useDispatch()
  const pending = useSelector( (state) => state.auth.pending)

  const logOut =  async (event) => {
    event.preventDefault()
    try {
      await wretch('/auth/sign_out')
        .headers({
          'X-CSRF-TOKEN': getCsrfToken()
        })
        .delete()
        .res( 
          () => {
            dispatch(clearAuthData())
          }
        )
    }
    catch (error) { console.error('Erreur lors de la déconnexion:', error) }
    finally { 
      window.location.href = "/auth/sign_in"
    }
  }

  return ( 
    <>
    { pending ? <li><span className="loading loading-ring loading-lg"></span></li> :
      <>
        <button id='logoutBtn' className='hidden btn btn-soft lg:block m-auto' onClick={logOut}>Se Déconnecter</button>
        <button id='logoutBtn' className='lg:hidden btn btn-square m-auto' onClick={logOut}>
          <PowerIcon className="h-7 w-7"/>
        </button>
      </>
    }
    </>
  )
}
